import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1CheckboxPrettyDisplayStyles: moduleStyleType = {
    icon: {
        width: '18px',
        height: '18px',
        marginRight: '12px', // icon is 18px. Checkbox icon takes 42px. So 42-18 = 24. 24/2 = 12px on each side.
        marginLeft: '12px', // icon is 18px. Checkbox icon takes 42px. So 42-18 = 24. 24/2 = 12px on each side.
        marginTop: 1,
        marginBottom: 1,
    },
}
